"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatefulContextMenu = exports.ContextMenu = exports.ContextMenuState = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ContextMenuPane_1 = require("./ContextMenuPane");
const context_1 = require("./context");
const state_1 = require("./state");
Object.defineProperty(exports, "ContextMenuState", { enumerable: true, get: function () { return state_1.ContextMenuState; } });
const useBehaviorSubject_1 = require("../../../hooks/useBehaviorSubject");
const context_2 = require("../../Popup/context");
const ArgsPane_1 = require("../ArgsPane");
const environment_1 = require("../../../utils/environment");
const doUseMobileSheet = environment_1.isTouch || environment_1.isMobile;
const importContextMenuMobile = () => Promise.resolve().then(() => tslib_1.__importStar(require('../ContextMenuMobile')));
const ContextMenuMobile = React.lazy(async () => ({
    default: (await importContextMenuMobile()).ContextMenuMobile,
}));
if (doUseMobileSheet)
    importContextMenuMobile().catch(() => { });
const ContextMenu = (props) => {
    const root = (props.depth ?? 0) === 0;
    if (root && doUseMobileSheet)
        return (React.createElement(React.Suspense, { fallback: null },
            React.createElement(ContextMenuMobile, { ...props })));
    return React.createElement(DesktopContextMenu, { ...props });
};
exports.ContextMenu = ContextMenu;
const DesktopContextMenu = ({ ...props }) => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: props spread creates new object each render
    const state = React.useMemo(() => state_1.ContextMenuState.create(props), [props]);
    state.props = props;
    return React.createElement(exports.StatefulContextMenu, { state: state });
};
const StatefulContextMenu = ({ state }) => {
    const popup = (0, context_2.usePopup)();
    state.onclose = state.props?.onClose ?? popup?.close;
    const path = (0, useBehaviorSubject_1.useBehaviorSubject)(state.path$);
    const currentMenu = (0, useBehaviorSubject_1.useBehaviorSubject)(state.menu$);
    const argsItem = state.argsItem.use();
    // Restore focus to the element that triggered the menu when it unmounts.
    React.useEffect(() => {
        const trigger = document.activeElement;
        return () => {
            if (trigger && typeof trigger.focus === 'function')
                requestAnimationFrame(() => trigger.focus());
        };
    }, []);
    const id = currentMenu.id ?? currentMenu.name;
    const minWidth = currentMenu.minWidth ?? state.minWidth ?? 220;
    if (argsItem) {
        const params = argsItem.params;
        if (params && params.length) {
            return (React.createElement(context_1.context.Provider, { value: state },
                React.createElement(ArgsPane_1.ArgsPane, { item: argsItem, params: argsItem.params ?? [], minWidth: minWidth, onCancel: () => state.argsItem.next(null), onSubmit: (list, map) => {
                        argsItem.onSubmit?.(list, map);
                        state.onclose?.();
                    } })));
        }
    }
    return (React.createElement(context_1.context.Provider, { value: state },
        React.createElement(ContextMenuPane_1.ContextMenuPane, { key: id, ...state.props, path: path, menu: currentMenu })));
};
exports.StatefulContextMenu = StatefulContextMenu;
